import React, { useEffect } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

function Shifts() {
  useEffect(() => {
    document.title = 'Shifts - Sales Assist';
    return () => {
      document.title = 'Sales Assist';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-lg bg-green-100">
            <ClockIcon className="w-6 h-6 text-green-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Shifts</h1>
            <p className="text-sm text-gray-600 mt-1">Manage work shifts and schedules</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-6">
        <div className="px-6">
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-12 text-center">
            <div className="max-w-md mx-auto">
              <ClockIcon className="w-20 h-20 text-gray-300 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Shift Management Coming Soon</h2>
              <p className="text-gray-600 mb-6">
                The shift management system is currently under development. This feature will allow you to:
              </p>
              <ul className="text-left text-gray-600 space-y-2 mb-8">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>Create and manage work shifts</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>Assign shifts to employees</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>View shift schedules and calendars</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2">•</span>
                  <span>Handle shift swaps and requests</span>
                </li>
              </ul>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="text-sm text-green-800">
                  <strong>Note:</strong> This feature will be available in a future update.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shifts;
